import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Showcase } from '../components/Showcase';
import { Features } from '../components/Features';
import { Faq } from '../components/Faq';
import { DemoCta } from '../components/DemoCta';
import { Footer } from '../components/Footer';

export function LandingPage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Showcase />
        <Features />
        <Faq />
        <DemoCta />
      </main>
      <Footer />
    </>
  );
}
